import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'map'
})
export class MappingPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const key = args[0][args[1]];
    return value[key] !== undefined ? value[key] : '';
  }

}
